/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PasswordChangeDTO interface.
 */
export function instanceOfPasswordChangeDTO(value) {
    return true;
}
export function PasswordChangeDTOFromJSON(json) {
    return PasswordChangeDTOFromJSONTyped(json, false);
}
export function PasswordChangeDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPassword': json['currentPassword'] == null ? undefined : json['currentPassword'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}
export function PasswordChangeDTOToJSON(json) {
    return PasswordChangeDTOToJSONTyped(json, false);
}
export function PasswordChangeDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
    };
}
